import axios from 'axios'

const tokenUrl = 'https://ai.china.com.cn/api/qn/token'
// const tokenUrl = 'http://192.168.1.171:3000/token'

// 获取token
function getToken () {
  return axios.get(tokenUrl, {
    dataType: 'jsonp'
  })
    .then(function (response) {
      let parsedata = {}
      if (typeof response === 'string' && response.length > 0) {
        parsedata = JSON.parse(response).data
      } else {
        parsedata = response.data
      }
      return parsedata
    })
    .catch(function (err) {
      console.log(err)
    })
}

export default getToken
